var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 17.2857H6.28571C5.86895 17.2857 5.46925 17.1202 5.17455 16.8255C4.87985 16.5308 4.71429 16.1311 4.71429 15.7143V13.3571H6.28571V15.7143H15.7143V13.3571H17.2857V15.7143C17.2857 16.1311 17.1202 16.5308 16.8255 16.8255C16.5308 17.1202 16.1311 17.2857 15.7143 17.2857ZM0 10.2143H22V11.7857H0V10.2143ZM17.2857 8.64286H15.7143V6.28571H6.28571V8.64286H4.71429V6.28571C4.71429 5.86895 4.87985 5.46925 5.17455 5.17455C5.46925 4.87985 5.86895 4.71429 6.28571 4.71429H15.7143C16.1311 4.71429 16.5308 4.87985 16.8255 5.17455C17.1202 5.46925 17.2857 5.86895 17.2857 6.28571V8.64286ZM22 6.28571H20.4286V1.57143H15.7143V0H22V6.28571ZM1.57143 6.28571H0V0H6.28571V1.57143H1.57143V6.28571ZM6.28571 22H0V15.7143H1.57143V20.4286H6.28571V22ZM22 22H15.7143V20.4286H20.4286V15.7143H22V22Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.d12e121ef3029d3810505e20d25a9c8d.svg";
export { ForwardRef as ReactComponent };